import { IFRResource } from "app/resources/ifrresource";
import { UserRightsListResource } from "app/resources/user/user-rights-list-resource";

export class RoleResource extends IFRResource {

    rid: number;

	private roleKey: string;
	
	private name: String;
	
	private description: String;
	
	private userRights: UserRightsListResource;
}
